export enum TrackerSourceType {
	LIST = "LIST",
	XLSX = "XLSX",
	EMPTY = "EMPTY",
}

/**
 * What a tracker source contributes: tracked people or tracked companies (PREC-3417).
 * Declared per source, so one tracker can hold a people file and a company file side by side.
 */
export enum TrackerEntityKind {
	PERSON = "PERSON",
	ORGANIZATION = "ORGANIZATION",
}

/** The lead selection an "import from a list" source applies to its source list. */
export enum TrackerImportPriorityPreset {
	ALL = "ALL",
	QUALIFIED = "QUALIFIED",
	P1 = "P1",
	P1_P2 = "P1_P2",
}
